/* import __COLOCATED_TEMPLATE__ from './print.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();